import { createGlobalStyle } from "styled-components";
import theme from "./theme"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GlobalStyle = createGlobalStyle`

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  :target {
    scroll-margin-top: 140px;
    scroll-behavior: smooth;
  }

  body {
    display: inline-block;
    font-family: ${theme.fonts.montSerrat};
    letter-spacing: 0.05em;
    margin: 0;
    padding: 0;
    padding-right: 0 !important;
    overflow-x: hidden;
    width: 100%;
  }

  header,
  footer {
    display: none;
  }

  .hs {
    header {
      display: block;

      @media (max-width:  ${theme.breakpoints.medium}) {
        display: flex;
      }
    }
  }

  nextjs-portal {
    display: none !important;
  }
  .arz-header,.footer.ty-footer,.ty-newsletter,.arz-header-mobile,#cvmodal-arezzo_modal_form_lead{
    display: none;
  }
  .hs-wrapper{
    position: relative;
    width: 100%;
    margin: 0 auto;
    max-width: 1440px;
    padding: 0 20px;
  }
  .hs {
    text-align: center;
  }

  img {
    max-width: 100%;
  }
  .MuiBackdrop-root{
    background-color: rgba(0, 0, 0, 0)!important;
  }


`;



export default GlobalStyle;
